import AlertBanner, { TAlertBannerProps } from "../alert-banner/alert-banner";
import styles from "./alert-banner-list.module.less";

type TAlertBannerListProps = {
  alertBanners: Array<TAlertBannerProps>;
  disableAnimations?: boolean;
};

const AlertBannerList = ({ alertBanners }: TAlertBannerListProps) => {
  return (
    <ul className={`max-width padded-sides centered ${styles.wrapper}`}>
      {alertBanners.map((alert, index) => (
        <li key={index}>
          <AlertBanner {...alert} />
        </li>
      ))}
    </ul>
  );
};

export default AlertBannerList;
